/* Popup di benvenuto: quando compare, invio del modulo, codice applicato. */
(function () {
  var dlg = document.getElementById('lv-pop');
  if (!dlg || typeof dlg.showModal !== 'function') return;

  var KEY = 'lvPopup';
  var POSTED = 'lvPopupPosted';
  var code = dlg.dataset.code;
  var delay = (parseInt(dlg.dataset.delay, 10) || 10) * 1000;
  var CLOSED = 'lvPopupClosed';
  // Chi arriva per lasciare una recensione (QR della card nel pacco, email di
  // richiesta recensione) ha gia' comprato: il 10% sul primo ordine non lo
  // riguarda e il popup coprirebbe il modulo. Su questo dispositivo non torna.
  var CLIENTE = 'lvPopupCliente';
  var RECENSIONE = /\/pages\/recensione/;
  var form = dlg.querySelector('form');
  var input = dlg.querySelector('input[type="email"]');
  var err = dlg.querySelector('.lv-pop__err');
  var shown = false;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return null; }
  }
  function write(v) {
    try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {}
  }

  function loadImage() {
    var img = dlg.querySelector('img[data-src]');
    if (!img) return;
    img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
    img.removeAttribute('data-src');
  }

  function open() {
    if (shown || dlg.open) return;
    if (document.querySelector('dialog[open]')) return;
    shown = true;
    loadImage();
    dlg.showModal();
  }

  function close() {
    // Chiuso senza iscriversi: non torna in questa visita, torna alla prossima.
    if (dlg.dataset.step !== 'ok') { try { sessionStorage.setItem(CLOSED, '1'); } catch (e) {} }
    dlg.close();
  }

  function applyCode() {
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' }).catch(function () {});
  }

  function success() {
    write({ s: 1 });
    dlg.dataset.step = 'ok';
    dlg.querySelector('[data-step="form"]').hidden = true;
    var ok = dlg.querySelector('[data-step="ok"]');
    ok.hidden = false;
    ok.querySelector('h2').focus();
    applyCode();
  }

  dlg.addEventListener('click', function (e) {
    if (e.target === dlg || e.target.closest('[data-close]')) close();
  });
  dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });

  input.addEventListener('input', function () {
    err.hidden = true;
    input.removeAttribute('aria-invalid');
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!input.checkValidity()) {
      err.hidden = false;
      input.setAttribute('aria-invalid', 'true');
      input.focus();
      return;
    }
    var btn = form.querySelector('[type="submit"]');
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = btn.dataset.busy;
    var fallback = function () {
      try { sessionStorage.setItem(POSTED, '1'); } catch (x) {}
      HTMLFormElement.prototype.submit.call(form);
    };
    fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
      .then(function (r) {
        if (r.ok && /customer_posted=true/.test(r.url)) success();
        else fallback();
      })
      .catch(fallback)
      .then(function () { btn.disabled = false; btn.textContent = label; });
  });

  // Ritorno dall'invio classico (sfida anti-spam o errore della chiamata fetch).
  var posted = false;
  try { posted = sessionStorage.getItem(POSTED) === '1'; sessionStorage.removeItem(POSTED); } catch (x) {}
  if (posted && /customer_posted=true/.test(location.search)) {
    open();
    success();
    return;
  }

  if (dlg.hasAttribute('data-design')) {
    document.addEventListener('shopify:section:select', function (e) {
      if (dlg.closest('[id="shopify-section-' + e.detail.sectionId + '"]')) { shown = false; open(); }
    });
    document.addEventListener('shopify:section:deselect', function () { if (dlg.open) dlg.close(); });
    return;
  }

  var cliente = false;
  try {
    if (RECENSIONE.test(location.pathname) || RECENSIONE.test(document.referrer) ||
        location.hash === '#judgeme_product_reviews') localStorage.setItem(CLIENTE, '1');
    cliente = localStorage.getItem(CLIENTE) === '1';
  } catch (e) {}

  var state = read();
  var closed = false;
  try { closed = sessionStorage.getItem(CLOSED) === '1'; } catch (e) {}
  if (!state || state.s || closed || cliente) return;

  var timer = setTimeout(open, delay);
  function onScroll() {
    var h = document.documentElement.scrollHeight - innerHeight;
    if (h > 0 && scrollY / h >= 0.5) { off(); open(); }
  }
  function onLeave(e) {
    if (e.clientY <= 0 && !e.relatedTarget) { off(); open(); }
  }
  function off() {
    clearTimeout(timer);
    removeEventListener('scroll', onScroll);
    document.removeEventListener('mouseout', onLeave);
  }
  addEventListener('scroll', onScroll, { passive: true });
  if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
    setTimeout(function () { document.addEventListener('mouseout', onLeave); }, 3000);
  }
})();
